import { getAppInfo } from 'util/appInfo';
import { SegmentProperty } from 'api';
import { FEATURES } from 'consts';
import { SegmentPropertyValue, FeaturesListType } from './types';

const { isK, isT } = getAppInfo();

const isWaitingLottieLayoutEnabled =
    process.env.REACT_APP_VCS_WAITING_LOTTIE_LAYOUT_ENABLED === 'true' || process.env.REACT_APP_IS_F === 'true';

const getPropertyValue = ({ booleanValue, dateValue, intValue, stringValue }: SegmentProperty): SegmentPropertyValue =>
    booleanValue ?? dateValue ?? intValue ?? stringValue;

const buildFeaturesMap = (properties: SegmentProperty[] | null): FeaturesListType => {
    if (!properties) return {} as FeaturesListType;

    return properties.reduce<FeaturesListType>((acc, property) => {
        const { key } = property;
        const value = getPropertyValue(property);

        if (key && value !== undefined) {
            acc[key as keyof FeaturesListType] = value;
        }

        return acc;
    }, {} as FeaturesListType);
};

export const getFullFeaturesList = (remoteProperties: SegmentProperty[] | null): FeaturesListType => {
    const localFeatureFlags: Partial<FeaturesListType> = {
        [FEATURES.LOCAL_VCS_WAITING_LOTTIE_LAYOUT_ENABLED]: isWaitingLottieLayoutEnabled,
        // Отдельная секция поднятых рук для всех брендов, кроме Tango (IS_T).
        // Для IS_T руки остаются в общем списке «Участники» с индикатором.
        [FEATURES.LOCAL_VCS_RAISED_HANDS_LIST_ENABLED]: !isT,
    };

    if (isK) {
        localFeatureFlags[FEATURES.LOCAL_VCS_AI_RECAP_ENABLED] = Boolean(
            remoteProperties?.find((property) => property.key === FEATURES.VCS_AI_RECAP_ENABLED)?.booleanValue,
        );
    }

    return { ...buildFeaturesMap(remoteProperties), ...localFeatureFlags };
};
